import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  user: null,
  userPropertyList: [],
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    loginUser: (state) => {
      state.token = null;
      state.user = null;
      state.userPropertyList = [];
      state.loginError = undefined;
    },
    setSession: (state, data) => {
      state.token = data.payload.token;
      state.user = {};
      state.user.firstName = data.payload.firstName;
      state.user.lastName = data.payload.lastName;
      state.user.email = data.payload.email;
      state.user.selectedProperty = data.payload.userDefaultProperty;
    },
    loginUserFailure: (state, action) => {
      state.user = null;
      state.loginError = action.payload;
    },
    cleanSession: (state) => {
      state.token = null;
      state.user = null;
      state.userPropertyList = [];
    },
    prepareApp: (state, data) => {
      const { userPropertyList = [] } = data.payload;
      state.userPropertyList = userPropertyList;
    },
    changeProperty: (state) => {
      state.changePropertyError = undefined;
    },
    selectProperty: (state, data) => {
      const selectedPropertyId = data.payload;
      state.user.selectedProperty = selectedPropertyId;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loginUser,
  setSession,
  loginUserFailure,
  cleanSession,
  prepareApp,
  changeProperty,
  selectProperty,
} = sessionSlice.actions;

export default sessionSlice.reducer;
